import { makeObservable, observable, runInAction } from 'mobx';
import { BaseStore } from '../baseStore';
import { RootStore } from '../rootStore';
import { HeadlinesService } from '/src/api';
import { Headlines } from '/src/lib/models';
import { TGetHeadlinesRequest } from '/src/lib/types';

export interface HeadlinesStoreProps {
  /**
   * Array of Headlines
   */
  headlines?: Headlines;
}

export class HeadlinesStore extends BaseStore implements HeadlinesStoreProps {
  headlines?: Headlines;

  constructor(rootStore: RootStore) {
    super(rootStore);

    makeObservable(this, {
      headlines: observable,
    });
  }

  /**** Headlines CRUD ****/

  /**
   * Gets a list of Headlines
   *
   * @param filters - Filters to use when parsing Headline results
   * @returns Filtered headlines
   */
  get = async (filters: TGetHeadlinesRequest) => {
    const headlines = await HeadlinesService.get(filters as TGetHeadlinesRequest);

    runInAction(() => (this.headlines = headlines));

    return headlines;
  };
}
